import React from 'react';
import { useGameStore, useRoomStore } from '@store/index';
import styles from './GameStatus.module.css';

export const GameStatus: React.FC = () => {
  const gameState = useGameStore((state) => state.gameState);
  const playerColor = useRoomStore((state) => state.playerColor);
  
  if (!gameState) return null;
  
  const getStatusMessage = () => {
    switch (gameState.gameStatus) {
      case 'waiting':
        return 'Waiting for opponent...';
      case 'ready':
        return 'Game starting...';
      case 'active':
        if (gameState.inCheck) {
          return `${gameState.currentTurn} is in check!`;
        }
        return gameState.currentTurn === playerColor ? 'Your turn' : "Opponent's turn";
      case 'finished':
        if (gameState.result) {
          switch (gameState.result.reason) {
            case 'checkmate':
              return `Checkmate! ${gameState.result.winner} wins!`;
            case 'stalemate':
              return 'Stalemate - Draw';
            case 'timeout':
              return `Time out! ${gameState.result.winner} wins!`;
            case 'resignation':
              return `${gameState.result.winner} wins by resignation`;
            case 'draw-agreement':
              return 'Draw by agreement';
            case 'draw-repetition':
              return 'Draw by repetition';
            case 'draw-50-move':
              return 'Draw by 50-move rule';
            case 'draw-insufficient-material':
              return 'Draw - Insufficient material';
            default:
              return 'Game finished';
          }
        }
        return 'Game finished';
      default:
        return '';
    }
  };
  
  const statusClass = gameState.gameStatus === 'finished' && gameState.result?.winner === playerColor
    ? styles.won
    : gameState.gameStatus === 'finished' && gameState.result?.winner && gameState.result.winner !== playerColor
    ? styles.lost
    : '';
  
  return (
    <div className={`${styles.status} ${statusClass}`}>
      <h3 className={styles.title}>Game Status</h3>
      <p className={styles.message}>{getStatusMessage()}</p>
      {gameState.gameStatus === 'active' && (
        <p className={styles.turn}>
          Move {gameState.fullMoveNumber}
        </p>
      )}
    </div>
  );
};